import type { BulkImport, BulkImportEntity, BulkImportStatus, BulkImportTotals } from '@/types/bulkImport'

export interface ActiveBulkImport {
  id: string
  entity: BulkImportEntity
  operationType: string
  status: BulkImportStatus
  fileName: string | null
  progressPercent: number
  processedCount: number
  totalCount: number
  totals: BulkImportTotals
  hasErrorReport: boolean
  hasResultReport: boolean
  hasCardFailures: boolean
  cardsFailed: number
  errorMessage: string | null
  createdAt: string
  finishedAt: string | null
  dismissed: boolean
}

const TERMINAL: BulkImportStatus[] = ['completed', 'failed', 'invalid']
export const isActiveTerminal = (status: BulkImportStatus): boolean => TERMINAL.includes(status)

// "ready" sem registros processáveis (total_count 0): não há job em execução para
// acompanhar. A linha exibe "Sem registros" e é terminal para fins de poll.
export const isEmptyReady = (status: BulkImportStatus, totalCount: number): boolean =>
  status === 'ready' && totalCount === 0

// Terminal para poll: status terminal OU "ready" sem registros. Usado tanto para
// decidir o que rastrear (Central) quanto o que continua pollável (activeBulkImports).
export const isPollTerminal = (status: BulkImportStatus, totalCount: number): boolean =>
  isActiveTerminal(status) || isEmptyReady(status, totalCount)

export function toActiveBulkImport(imp: BulkImport): ActiveBulkImport {
  return {
    id: imp.id,
    entity: imp.entity,
    operationType: imp.operation_type,
    status: imp.status,
    fileName: imp.file_name,
    progressPercent: imp.progress.percent,
    processedCount: imp.progress.processed_count,
    totalCount: imp.progress.total_count,
    totals: imp.totals,
    hasErrorReport: imp.has_error_report,
    hasResultReport: imp.has_result_report,
    hasCardFailures: imp.has_card_failures,
    cardsFailed: imp.cards_failed,
    errorMessage: imp.error_message,
    createdAt: imp.created_at,
    finishedAt: imp.finished_at,
    dismissed: false,
  }
}
